/**
 * Time Tracking Page
 */

import React, { useState } from 'react';
import { useTimeStore } from '../store/timeStore';
import { useDataSubscriptions } from '../hooks/useDataSubscriptions';
import Timer from '../components/Timer';
import TimeEntryList from '../components/TimeEntryList';
import TimeEntryModal from '../components/TimeEntryModal';

const TimeTracking = () => {
  useDataSubscriptions();
  
  const timeEntries = useTimeStore((state) => state.timeEntries);
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState('all'); // all, unbilled, invoiced

  // Filter entries based on selection
  const filteredEntries = timeEntries.filter(entry => {
    if (entry.isRunning) return false; // Exclude running timer
    if (filter === 'unbilled') return !entry.invoiced;
    if (filter === 'invoiced') return entry.invoiced;
    return true;
  });

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <div>
          <h1>Time Tracking</h1>
          <p style={{ color: 'var(--text-secondary)', margin: '0.5rem 0 0 0' }}>
            Track your billable hours and manage time entries
          </p>
        </div>
        <button 
          className="btn btn-primary"
          onClick={() => setShowModal(true)}
        >
          + Add Manual Entry
        </button>
      </div>

      <Timer />

      <div style={{ marginTop: '2rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h2>Time Entries</h2>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button
              className={`btn ${filter === 'all' ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setFilter('all')}
            >
              All
            </button>
            <button
              className={`btn ${filter === 'unbilled' ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setFilter('unbilled')}
            >
              Unbilled
            </button>
            <button
              className={`btn ${filter === 'invoiced' ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setFilter('invoiced')}
            >
              Invoiced
            </button>
          </div>
        </div>

        <TimeEntryList entries={filteredEntries} />
      </div>

      {showModal && (
        <TimeEntryModal
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default TimeTracking;
